import { Flex, Text } from "@theorgchartdev/storybook";

export const RecordSourceRow = ({ fVPair, sourceMap }) => {
  const { source: sourceKey } = fVPair;
  const staticTextStyle = {
    minHeight: "15px"
  };

  const source = sourceMap ? sourceMap.get(sourceKey) : null;

  const sourceText = source ? sourceKey + " (" + source.name + ")" : sourceKey;

  return (
    <Flex gap={"8px"} alignItems={"center"}>
      {source?.icon && (
        <img
          className="responsiveImage"
          src={source.icon}
          alt="fireSpot"
          style={{ width: "16px", height: "16px" }}
        />
      )}
      <Text size="xsmall" style={staticTextStyle}>
        {sourceText}
      </Text>
    </Flex>
  );
};
